import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {IconButton, Tooltip} from '@material-ui/core';
import {Edit as EditIcon} from '@material-ui/icons';
import {
  FilteringState,
  IntegratedFiltering,
  IntegratedSorting,
  SortingState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import {useWindowResize} from '@ozgene/gp5.hooks.use-window-resize';
import {sortByProperty} from '@ozgene/gp5.utils.sort-functions';
import CustomTableLoading from 'Utility/CustomTableLoading';
import {ColumnDefinedFilterCell} from 'Components/ColumnDefinedFilterCell';
import {CustomRowComponent} from 'Components/CustomRowComponent';

const columnExtensions = [
  {columnName: 'actions', sortingEnabled: false, filteringEnabled: false},
];
const consumableColumnExtensions = [
  {columnName: 'name', wordWrapEnabled: true},
  {columnName: 'actions', width: 95},
  {columnName: 'supplier', width: 200, wordWrapEnabled: true},
  {columnName: 'productCode', width: 150, wordWrapEnabled: true},
];

export default function ConsumableList(props) {
  const {consumables, onEditConsumable} = props;
  const {height} = useWindowResize();
  const [isLoading, setIsLoading] = useState(true);
  const integratedSortingColumnExtensions = [
    {
      columnName: 'name',
      compare: sortByProperty((x) => x),
    },
  ];
  const getActionColumn = (row) => (
    <Tooltip title="Edit Consumable">
      <IconButton
        size="small"
        color="primary"
        onClick={() => onEditConsumable(row)}
      >
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
  const consumableColumns = [
    {
      name: 'name',
      title: 'Name',
      getCellValue: (row) => row.name,
    },
    {
      name: 'productCode',
      title: 'Procduct Code',
      getCellValue: (row) => row.productCode,
    },
    {
      name: 'supplier',
      title: 'Supplier',
      getCellValue: (row) => row.supplier,
    },
    {
      name: 'actions',
      title: 'Actions',
      getCellValue: getActionColumn,
      CustomCellFilterComponent: false,
    },
  ];

  useEffect(() => {
    if (consumables.length > 0) {
      setIsLoading(false);
    }
  }, [consumables]);

  return !isLoading ? (
    <Grid rows={consumables} columns={consumableColumns}>
      <FilteringState columnExtensions={columnExtensions} />
      <SortingState columnExtensions={columnExtensions} />
      <IntegratedFiltering />
      <IntegratedSorting columnExtensions={integratedSortingColumnExtensions} />
      <VirtualTable
        height={height - 130}
        columnExtensions={consumableColumnExtensions}
        rowComponent={CustomRowComponent}
      />
      <TableHeaderRow showSortingControls />
      <TableFilterRow
        showFilterSelector={true}
        cellComponent={ColumnDefinedFilterCell}
      />
    </Grid>
  ) : (
    <CustomTableLoading />
  );
}

ConsumableList.propTypes = {
  consumables: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      productCode: PropTypes.string,
      supplier: PropTypes.string,
    }),
  ),
  onEditConsumable: PropTypes.func.isRequired,
};
